export const STORAGE_KEYS = {
  localUser: 'localUser',
  localEmpresa: 'localEmpresa',
  localToken: 'localToken',
  localCookies: 'localCookies',
  localFilterLead: 'localFilterLead'
};
